<template>
    <!--
        NOTE : This component is to be used
        ONLY inside boostrap-vue's <b-nav-item-dropdown>
    -->
    <div>
        <b-dropdown-item
            v-if="isHideArrowWhenListEmpty && list.length === 0"
            @click.native.capture.prevent.stop
        >
            <div class="title-text">
                <i
                    :class="[
                        title.icon,
                        { 'nested-blink-indicator': title.dot_indicator }
                    ]"
                ></i>
                {{ title.text }}
            </div>
        </b-dropdown-item>
        <li
            v-else
            :id="componentId"
            class="dropdown-nested"
            @mouseover="onMouseOver"
        >
            <b-dropdown-item @click.native.capture.prevent.stop>
                <div class="title-text">
                    <i
                        :class="[
                            title.icon,
                            { 'nested-blink-indicator': title.dot_indicator }
                        ]"
                    ></i>
                    {{ title.text }}
                </div>
            </b-dropdown-item>
            <div class="dropdown-nested-items group" id="nested-group">
                <component
                    v-for="(item, i) in list"
                    :item="item"
                    :key="i"
                    :is="item.icon === 'divider' ? 'divider' : 'nested-item'"
                    @click="
                        item.function_code
                            ? triggerParentFunction(item.function_code)
                            : null
                    "
                />
            </div>
        </li>
    </div>
</template>
<script>
import divider from "./divider";
import nestedItem from "./nested-item";

export default {
    components: {
        divider,
        nestedItem
    },
    props: {
        isHideArrowWhenListEmpty: {
            type: Boolean,
            default: false
        },
        title: {
            type: Object,
            default() {
                return {
                    text: "",
                    icon: ""
                };
            }
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        componentId() {
            return "dropdown-nested-" + this._uid;
        }
    },
    methods: {
        triggerParentFunction(functionCode) {
            this.$emit("trigger-function", functionCode);
        },
        onMouseOver() {
            let body = document.getElementsByTagName("body")[0];
            let nested = document
                .getElementById(this.componentId)
                .getElementsByClassName("dropdown-nested-items")[0];

            if (body && nested) {
                let bodyDetails = body.getBoundingClientRect();
                let nestedItemDetails = nested.getBoundingClientRect();

                if (nestedItemDetails.bottom > bodyDetails.bottom) {
                    let newHeight =
                        bodyDetails.height +
                        (nestedItemDetails.bottom - bodyDetails.bottom) +
                        50;
                    body.style.height = newHeight + "px";
                }
            }
        }
    }
};
</script>
<style type="text/css" lang="scss">
$background-hover-color: #c9ccde;

.dropdown-nested {
    position: relative;

    &:hover {
        background: $background-hover-color;

        > .dropdown-nested-items {
            display: block;
        }
    }

    .title-text {
        &::after {
            display: block;
            float: right;
            width: 0;
            height: 0;
            margin-top: 5px;
            margin-right: -10px;
            border-color: transparent;
            border-left-color: #cccccc;
            border-style: solid;
            border-width: 5px 0 5px 5px;
            content: " ";
        }
    }

    .dropdown-nested-items {
        display: none;
        position: absolute;
        left: 100%;
        top: -6px;

        border: 1px solid rgba(0, 0, 0, 0.2);
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        background: #fff;
        transition: right 100;
        padding: 5px 0;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    }
}

.btn-to-close {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -10;
}
</style>
